<template>
    <div>
        <PCMethod 
            v-if="getJson && isMobile === false" 
            :json="json"
        />
        <MobMethod 
            v-else-if="getJson && isMobile === true" 
            :json="json"
         />
    </div>
</template>
<script>

import PCMethod from '@/components/pc/PCMethod'
import MobMethod from '@/components/mobile/MobMethod'

// import jquery from 'jquery'

import methodJson from '@/json/method'

import '@/assets/less/module/module-base-list-ulmoudle1_service-list-ul.less'

export default {
    name: 'Method',
    props: {
        isMobile: Boolean
    },
    components: {
        PCMethod,
        MobMethod
    },
    data: function(){
        return {
            getJson: true,
            json: methodJson
        }
    },
    mounted() {
        // let _this = this;
        // window.getAjaxJson = {};
        // jquery.get('./json/service.js', function(){
        //    _this.json =  window.getAjaxJson;
        //    _this.getJson = true;
        // });       
    }

}
</script>

